function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownSort1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 6532",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6096"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 551",
    width: 18,
    height: 14,
    rx: 3,
    style: {
      fill: "#ffc27a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Back Button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.185 3.829 0l3.83 4.185",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillRule: "evenodd"
    },
    transform: "rotate(-180 6.382 4.546)",
    "data-name": "icons/d/Down-arrow-16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownSort1);
export default __webpack_public_path__ + "static/media/DropDownSort1.26b1c4ee738d18ba9c15f50349991eac.svg";
export { ForwardRef as ReactComponent };